import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcAdd(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a.75.75 0 0 1-.75.75H4.75a.75.75 0 0 1 0-1.5h14.5A.75.75 0 0 1 20 12",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4a.75.75 0 0 1 .75.75v14.5a.75.75 0 0 1-1.5 0V4.75A.75.75 0 0 1 12 4",
    clipRule: "evenodd"
  }));
}
var IcAdd = createNolIcon(/*#__PURE__*/forwardRef(SvgIcAdd));

export { IcAdd as I };
